/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: '/',
    name: 'Inicio',
    slug: 'inicio',
    icon: 'HomeIcon',
    i18n: 'Inicio'
  },
  {
    url: '/dashboard/anuncios',
    name: 'Anuncios',
    slug: 'anuncios',
    icon: 'CastIcon',
    i18n: 'Anuncios'
  },
  {
    url: '/dashboard/documentacion',
    name: 'Documentacion',
    slug: 'documentacion',
    icon: 'BookIcon',
    i18n: 'Documentacion'
  },
  {
    url: null,
    name: 'Administración',
    slug: 'administracion',
    icon: 'UsersIcon',
    i18n: 'Administración',
    submenu: [
      {
        url: '/administracion/usuarios',
        name: 'Usuarios',
        slug: 'usuarios',
        i18n: 'Usuarios'
      }
    ]
  },
  {
    url: null,
    name: 'Configuración',
    slug: 'configuración',
    icon: 'SettingsIcon',
    i18n: 'Configuración',
    submenu: [
      {
        url: '/configuracion/empresas',
        name: 'Empresas',
        slug: 'empresas',
        i18n: 'Empresas'
      },
      {
        url: '/configuracion/val-sectores',
        name: 'Sectores',
        slug: 'sectores',
        i18n: 'Sectores'
      },
      {
        url: '/configuracion/val-productos',
        name: 'Productos',
        slug: 'productos',
        i18n: 'Productos'
      },
      {
        url: '/configuracion/importar-val-productos',
        name: 'Importar productos',
        slug: 'importar-productos',
        i18n: 'Importar productos'
      },
      {
        url: '/configuracion/val-tipos-documentos',
        name: 'Tipos de documentos',
        slug: 'tipos-de-documentos',
        i18n: 'Tipos de documentos'
      },
      {
        url: '/configuracion/anuncios',
        name: 'Anuncios',
        slug: 'anuncios',
        i18n: 'Anuncios'
      },
      {
        url: '/configuracion/documentacion',
        name: 'Documentacion',
        slug: 'subir-documentacion',
        i18n: 'Documentacion'
      }    
    ]
  },
  {
    url: null,
    name: 'Gestión',
    slug: 'gestion',
    icon: 'CompassIcon',
    i18n: 'Gestión',
    submenu: [
      {
        url: '/gestion/clientes',
        name: 'Clientes',
        slug: 'clientes',
        i18n: 'Clientes'
      },
      {
        url: '/gestion/operaciones',
        name: 'Operaciones',
        slug: 'operaciones',
        i18n: 'Operaciones'
      },
      {
        url: '/gestion/presupuestos',
        name: 'Presupuestos',
        slug: 'presupuestos',
        i18n: 'Presupuestos'
      }
    ]
  },
  {
    url: null,
    name: 'Informes',
    slug: 'Informes',
    icon: 'BarChart2Icon',
    i18n: 'Informes',
    submenu: [
      {
        url: '/informes/comerciales',
        name: 'Comerciales',
        slug: 'comerciales',
        i18n: 'Comerciales'
      }
    ]
  }
]
